/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccreditationMedicineMaterialsAliases {
  ACTION_ADD = 'action-add',
  CARD_MEDICINE_MATERIALS = 'card-medicine-materials',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FETCH_ACTION = 'fetch-action',
  FETCH_MEDICINE_MATERIAL = 'fetch-medicine-material',
  FETCH_MEDICINE_MATERIALS_LIST = 'fetch-medicine-materials-list',
  FETCH_PENDENCIES = 'fetch-pendencies',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_10 = 'field-10',
  FIELD_ACTION = 'field-action',
  FIELD_CODE = 'field-code',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_MEDICINE_MATERIAL = 'field-medicine-material',
  FIELD_MEDICINE_MATERIAL_VALUE = 'field-medicine-material-value',
  FIELD_VALUE = 'field-value',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_0 = 'form-0',
  FORM_MEDICINE_MATERIAL = 'form-medicine-material',
  INPUT_CODE = 'input-code',
  INPUT_DESCRIPTION = 'input-description',
  INPUT_MEDICINE_MATERIAL_CODE = 'input-medicine-material-code',
  INPUT_MEDICINE_MATERIAL_VALUE = 'input-medicine-material-value',
  LAYOUT_0 = 'layout-0',
  LEGENDS = 'legends',
  LOCATOR_FIELD_MEDICINE_MATERIAL = 'locator-field-medicine-material',
  LOCATOR_MEDICINE_MATERIAL = 'locator-medicine-material',
  MAPPER_3 = 'mapper-3',
  MAPPER_10 = 'mapper-10',
  MODAL_MATERIAL = 'modal-material',
  PANEL_0 = 'panel-0',
  PANEL_ADD = 'panel-add',
  PANEL_MEDICINE_MATERIALS = 'panel-medicine-materials',
  PANEL_PENDENCIES = 'panel-pendencies',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TOAST_NOTIFICATION = 'toast-notification',
  UNBOXED_AUTOCOMPLETE_ACTION = 'unboxed-autocomplete-action',
}
export { AccreditationMedicineMaterialsAliases };
